import React from 'react';
import { FormGroup, InputGroup, Input, InputGroupText } from 'reactstrap';
import { SmallFormFeedback } from '../../../../utils/budget-tool-specific';
import { RebelColors } from '../../../../styles/rebel-experiences';
import styled from 'styled-components';

const RebelFormInputIndex = (props) => {

    const handleInputChange = (value) => {
        const newData = {...props.data};
        newData[props.id] = value;
        props.setData(newData);
    }

    const toggle = () => {
        props.toggleAction(!props.toggleValue);
    }

    return (
        <React.Fragment>
            {<FormGroup>
                <RebelLabel for={props.id}>{props.title}</RebelLabel>
                <InputGroup>
                    {props.currency && <RebelInputGroupText>{props.currency}</RebelInputGroupText> }
                    <RebelInput
                                    type={props.type}
                                    disabled={props.client}
                                    value={props.data[props.id]}
                                    onChange={e => handleInputChange(e.target.value)}
                                    fontSize={props.fontSize ? props.fontSize : "16px"}
                                    readOnly={props.client}>
                        {props.options}
                    </RebelInput>
                    {props.contingency && <RebelInputGroupText>%
                    </RebelInputGroupText> }
                    <RebelFormFeedback>Required</RebelFormFeedback>
                    {props.toggle && <InputGroupText style={{marginRight:"1px", backgroundColor: RebelColors.surface, border:"none", fontSize:"12px", color: RebelColors.primary}}>
                        {props.toggleTitle}
                    </InputGroupText>}
                    {props.toggle && <Input
                        addon
                        aria-label="Checkbox for following text input"
                        type="checkbox"
                        checked={props.toggleChecked}
                        value = {props.toggleValue}
                        onChange={() => toggle()}
                    />}
                </InputGroup>
            </FormGroup> }
        </React.Fragment>
    )
}

export default RebelFormInputIndex;

const RebelLabel = styled.label`
    color: ${RebelColors.gold};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

const RebelInput = styled(Input)`
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    margin: ${props => props.fontSize === "16px" ? "" : "0px 0px"};
    border: 1px solid ${RebelColors.border};
    border-radius: 6px !important;
    background-color: #3b3f45;
    color: ${RebelColors.text} !important;
    padding: ${props => props.fontSize === "30px" ? "12px 16px" : "10px 16px"};
    min-height: 46px;
    transition: all 0.3s ease;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: none;
        color: ${RebelColors.text} !important;
        outline: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }

    &:disabled, &:read-only {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted} !important;
        cursor: not-allowed;
    }

    &[type="select-one"]:not(:disabled):not(:read-only) {
        cursor: pointer;
    }

    select&:not(:disabled):not(:read-only) {
        cursor: pointer;
    }

    option {
        background-color: #3b3f45;
        color: ${RebelColors.text};
    }
`;

const RebelInputGroupText = styled(InputGroupText)`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    color: ${RebelColors.text};
    border-radius: 6px !important;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;
